import useDimensions from '@react/shared/hooks/useDimensions';
import { useCallback, useState } from 'react';
import { FAQContentProps } from 'sly/agentsPage/components/AgentsContent/FAQSection/FAQContent/FAQTile/FAQContent.types';
import Chevron from 'sly/icons/Chevron';
import Heading from 'sly/system/Heading';

export default function FAQContent({
  className,
  borderless,
  title,
  description,
}: FAQContentProps) {
  const { ref: measureRef, dimensions } = useDimensions();
  const [collapsed, setCollapsed] = useState(false);
  const { height: maxHeight } = dimensions;

  const onClick = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  const border = borderless
    ? 'b-0 rounded-0'
    : 'border-l-[0.062rem] border-r-[0.062rem] rounded';
  const flipped = collapsed
    ? '-scale-x-100 -scale-y-100'
    : 'scale-x-100 scale-y-100';
  const contentHeight = !collapsed ? `${maxHeight}px` : 0;
  const overflow = collapsed
    ? 'overflow-hidden'
    : 'overflow-visible animate-[0.4s_delay-overflow]';
  return (
    <section
      className={`faq-section-transition mb-0 w-full rounded-none first:rounded-t-2xl last:rounded-b-2xl ${border} ${className} border-b`}
    >
      <div
        className='grid grid-cols-[auto_auto] justify-between py-4 px-6 hover:cursor-pointer'
        onClick={onClick}
        data-tp-id='gen-div-3f01d363-ab20-4298-961d-dabd59e61473'
      >
        <Heading
          as='h4'
          className='overflow-hidden text-ellipsis whitespace-nowrap text-[18px] font-medium'
          font='title-small-azo'
          data-tp-id='gen-Heading-046a1a3f-53f0-45c6-96a3-6d02f14f0097'
        >
          {title}
        </Heading>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <Chevron className={flipped} />
      </div>
      <div
        style={{ height: contentHeight }}
        className={`animate-[0.4s_delayOverflow] transition-[height] duration-200 ease-out ${overflow}`}
        data-tp-id='gen-div-6142424b-996b-4f77-8754-e5d0540baf57'
      >
        <div
          ref={measureRef}
          data-tp-id='gen-div-aa1aed2b-ce9c-4111-b47e-0e2cdbb8d311'
        >
          <div
            className={`py-0 px-6 ${collapsed ? 'pb-0' : 'pb-6'}`}
            data-tp-id='gen-div-5ba87b47-2ab8-4ab8-8804-355c6d9506a2'
          >
            <div
              className='text-gray-500'
              data-tp-id='gen-div-5fdcf9a4-46e3-4267-8a96-ec172f810dac'
            >
              {description}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
